import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CheckIcon from "@mui/icons-material/Check";
import parse from "html-react-parser";
import SearchButton from "../../../../../newTestPrep/newComponent/NewButtonComp/SearchButton";
import CustomTextFieldComp from "../../../../../newTestPrep/newComponent/customTextFieldComp";
export default function TemplateForm({
  onSelectedData,
  handelclosetemplatepopup,
  showSnackbar
}) {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const [templatelist, setTemplatelist] = useState([]);
  const [templateTitle, setTemplateTitle] = useState("");
 const [loader,setLoader] =useState(false)
  const [openRow, setOpenRow] = React.useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true)
        const response = await fetch(`${API_ENDPOINT}route/fetchtemplate`);
        if (response.ok) {
          const data = await response.json();

          setTemplatelist(data);
          console.log(data)
          setLoader(false); 
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoader(false); 
      }
    };

    fetchData();
  }, []);

  const handleSearch = () => {
    const filtered = templatelist.filter((template) =>
      template.template_title
        .toLowerCase()
        .includes(templateTitle.toLowerCase())
    );
    setTemplatelist(filtered);
  };

  const toggleRow = (index) => {
    setOpenRow((prevOpenRow) => (prevOpenRow === index ? null : index));
  };

  const handelclick = (description,subject, attachments) => {
    console.log(description);
    showSnackbar("Template selected", "success");
    onSelectedData(description,subject,attachments);
     handelclosetemplatepopup();
  
   
  };
  return (
    <>
      <Grid container direction="row" alignItems="center" spacing={2} mb={3}>
        <Grid item xs={6} lg={5}>
          <Typography variant="h6" sx={{  textAlign: "left" }}>
            Search By Template Title
          </Typography>
          <CustomTextFieldComp
          size="normal"
            id="outlined-basic"
            variant="outlined"
            fullWidth
            InputProps={{
              style: {
                borderRadius: "10px",
              },
            }}
            value={templateTitle}
            onChange={(e) => setTemplateTitle(e.target.value)}
          />
        </Grid>

        <Grid item xs={4} lg={3} marginTop="8px">
          <SearchButton
          size="small"
        showIcon={true}
            onClick={handleSearch}
          >
            {" "}
            search{" "}
          </SearchButton>
        </Grid>
      </Grid>

      {loader ? ( // If loader is true, display loader
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) :  templatelist.length === 0 ? ( // If loader is false and data is empty, display "No data"
      <Typography>No data</Typography>
    ) : (
      <TableContainer component={Paper}>
        <Table
          aria-label="simple table"
          sx={{ border: "1px solid rgba(224, 224, 224, 1)" }}
        >
          <TableHead>
            <TableRow sx={{ height: "10px" }}>
              <TableCell
                sx={{
                  background: "#E1EBEE",
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                  padding: "10px",
                  lineHeight: "1",
                  verticalAlign: "top",
                  fontWeight: 600,
                  fontSize:'0.7rem'
                }}
              >
                Template Name
              </TableCell>
              <TableCell
                sx={{
                  background: "#E1EBEE",
                  height: "10px",
                  padding: "10px",
                  lineHeight: "1",
                  verticalAlign: "top",
                  textAlign: "center",
                  fontWeight: 600,
                   fontSize:'0.7rem'
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templatelist.map((item, index) => (
              <React.Fragment key={item.id}>
                <TableRow>
                  <TableCell
                   
                    sx={{
                       fontSize:'0.7rem',
                      borderBottom: "1px solid rgba(224, 224, 224, 1)",
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "10px",
                      lineHeight: "1",
                    }}
                  >
                   {item.template_title}

                    {openRow === index && (
                      <>
                      <Typography sx={{ marginTop: "10px" }}>

                        <Typography variant="h5" sx={{ marginTop:'10px'}}>Body</Typography>
                      {parse(String(item.description))}

                      </Typography>
                     
                      </>
                    )}
                  </TableCell>

                  <TableCell
                    sx={{
                      borderBottom: "1px solid rgba(224, 224, 224, 1)",
                      display: "flex",
                      flexDirection: "row",
                      padding: "10px",
                      lineHeight: "1",
                    }}
                  >
                    <Box
                      onClick={() => toggleRow(index)}
                      sx={{
                        height: "15px",
                        width: "18px",
                        borderRadius: "40%",
                        background: "blue",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <RemoveRedEyeOutlinedIcon fontSize="small"   style={{ fontSize: "0.8rem" }} />
                    </Box>
                    <Box
                      onClick={() => handelclick(item.description,item?.email_subject, item?.attachments)}
                      sx={{
                        height: "15px",
                        width: "18px",
                        borderRadius: "40%",
                        background: "green",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "10px",
                      }}
                    >
                      <CheckIcon fontSize="small"   style={{ fontSize: "0.8rem" }} />
                    </Box>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
        )}
    </>
  );
}
